import baseUrl from "../config/baseUrl";

const restoreAllDocuments = async ({ token, id }) => {
  const formData = new FormData();
  formData.append("document_id", id);
  try {
    const response = await fetch(`${baseUrl}/apireact/bulk_restore_documents`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default restoreAllDocuments;
